import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { visualizerActions, uiActions } from '../../store';
import { useEffect, useState } from 'react';
import styles from './SurfacesMenuList.module.css';
import SurfacesMenuItem from '../SurfaceMenuItem/SurfaceMenuItem';


export default function SurfacesMenuList({location}) {
  const urlParams = useParams();
  const dispatch = useDispatch();
  const activeSurface = useSelector(state => state.visualizer.activeSurface);
  const appliedProducts = useSelector(state => state.visualizer.appliedProducts);
  const [surfacesList, setSurfacesList] = useState([]);


  const toPlainSurface = (src) => ({
    name: src?.name ?? 'Unknown',
    location: location,
  });


   const setSurfaces = (isInitialSet) => {
      const collected = [];
    
      document.getElementById('chamViz').applyByFilter("", "", function (newSel, currentSelectedSurface) {
        const src = currentSelectedSurface ?? this ?? {};
        const surface = toPlainSurface(src);
        collected.push(surface); 
      });

      //auto select the first surface
      if(collected.length > 0 && isInitialSet && activeSurface == null){
          dispatch(visualizerActions.setActiveSurface(collected[0]));
      }
      dispatch(visualizerActions.setSurfaceList(collected));
      setSurfacesList(collected);
  };

  useEffect(() => {
    document.getElementById('chamViz').addEventListener('ready', function (result) {
        setSurfaces(true);
    });
  }, [urlParams.specifier]);

   useEffect(() => {
    setSurfaces(false);
  }, [activeSurface]);


const surfaceList = surfacesList.map((surface, i) => {

  return (
    <SurfacesMenuItem
      index={i}
      key={`${i}-{${surface}}`}
      surface={surface}
    />
  );
});




  return <div>{surfaceList}</div>;
}
